import { render, staticRenderFns } from "./TimelineButton.vue?vue&type=template&id=1871b40f"
import script from "./TimelineButton.vue?vue&type=script&lang=js"
export * from "./TimelineButton.vue?vue&type=script&lang=js"
import style0 from "./TimelineButton.vue?vue&type=style&index=0&id=1871b40f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports